export function removePropertiesFromObj<
  T extends Record<string, any>,
  K extends keyof T
>(obj: T, keys: K[]) {
  const newObj = { ...obj };
  keys.forEach((key) => delete newObj[key]);

  return newObj;
}
